import React, { useState, useEffect, useRef } from "react";
import { Toast, Modal } from "../../Components";
import GalleryAdd from "../Gallery/GalleryAdd";
import MyProfileListing from "../../Pages/MyProfile/MyProfileListing";
import { useNavigate } from "react-router-dom";
import { getCache, setCache } from "../../Helpers/cachedata";
import {
  influencerService,
  alertService,
  galleryService,
  commonapiService,
} from "../../Services";

export default function PublicProfile(props) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    displayname: "",
    gender: "",
    country_id: "",
    reach: "",
    linktree: "",
    bio: "",
    profile_img: "",
    uploaded_profile_photo: "",
    audience_0_12: "0",
    audience_13_17: "0",
    audience_18_24: "0",
    audience_25_34: "0",
    audience_35_44: "0",
    audience_45_54: "0",
    audience_55_64: "0",
    audience_65plus: "0",
    categories: [],
  });

  const [toastList, setToastList] = useState([]);
  const [categoriesData, setCategoriesData] = useState({});
  const [galleryList, setGalleryList] = useState([]);
  const [pageSize, setPageSize] = useState(3);
  const [page, setPage] = useState(1);
  const [error, setError] = useState(false);
  const [newGalleryUploaded, setNewGalleryUploaded] = useState([]);
  const [tab, setTab] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [countOfImage, setCountOfImage] = useState(0);
  const [indexForAction, setIndexForAction] = useState(0);
  const [isFormValidToSave, setIsFormValidToSave] = useState(false);
  const [country, setCountry] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [PublicProfileData, setPublicProfileData] = useState(null);

  let refAbout = useRef(null);
  let refInfo = useRef(null);

  const updateForm = (data) => {
    setForm((prevForm) => ({ ...prevForm, ...data }));
  };

  const setInput = (key) => (event) => {
    props.setShowConfirmInfModal(true);
    updateForm({ [key]: event.target.value });
  };

  useEffect(() => {
    props.setShowConfirmInfModal(false);
    setPublicProfileData();
    async function fetchCategoriesData() {
      try {
        const cachedCategory = getCache("category");
        const res = await commonapiService.getCategories();

        if (!cachedCategory && res.success && res.data) {
          setCategoriesData(res.data);
          setCache("category", res.data);
        } else if (cachedCategory) {
          setCategoriesData(cachedCategory);
        }

      } catch (err) {
        addToast({ error: true, msg: err.message });
      }
    }

    async function fetchCountry() {
      try {
        const cachedDataforCountry = getCache("country");
        const res = await commonapiService.getCountry();
        if (!cachedDataforCountry && res.success && res.data) {
          setCountry(res.data);
          setCache("country", res.data);
        } else if (cachedDataforCountry) {
          setCountry(cachedDataforCountry);
        }
      } catch (err) {
        addToast({ error: true, msg: err.message });
      }
    }
    async function fetchOtherConfigData() {
      try {
        const res = await commonapiService.getConfigData();
        if (res) {
          setConfigData(res);
        }
      } catch (err) {
        addToast({
          error: true,
          msg: err,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    fetchInfluencerData();
    fetchCategoriesData();
    fetchCountry();
    fetchOtherConfigData();
  }, []);

  async function fetchInfluencerData() {
    try {
      const res = await influencerService.getPublicProfileData();
      if (res.success && res.data) {
        setPublicProfileData(res?.data);
        const cachedDataforCountry = getCache("country");

        if (!cachedDataforCountry) {
          const countryRes = await commonapiService.getCountry();
          if (countryRes.success && countryRes.data) {
            setCountry(countryRes.data);
            setCache("country", countryRes.data);
          }
        } else {
          setCountry(cachedDataforCountry);
        }
        const profileData = res.data.profile || {};
        const categories = res.data.categories || [];

        const transformedData = {
          displayname: profileData.displayname || "",
          gender: profileData.gender || "",
          country_id: profileData.country_id || "",
          reach: profileData.reach || "",
          linktree: profileData.linktree || "",
          bio: profileData.bio || "",
          profile_img: profileData.profile_img || "",
          uploaded_profile_photo: res.uploaded_profile_photo || "",
          audience_0_12: profileData.audience_0_12 || "0",
          audience_13_17: profileData.audience_13_17 || "0",
          audience_18_24: profileData.audience_18_24 || "0",
          audience_25_34: profileData.audience_25_34 || "0",
          audience_35_44: profileData.audience_35_44 || "0",
          audience_45_54: profileData.audience_45_54 || "0",
          audience_55_64: profileData.audience_55_64 || "0",
          audience_65plus: profileData.audience_65plus || "0",
          profile_img_url: profileData.profile_img_url || "",
          categories: categories,
        };

        setForm(transformedData);
      }
    } catch (err) {
      alertService.error(err);
      console.error("Error fetching profile data:", err);
    }
  }

  useEffect(() => {
    fetchData();
  }, [page, pageSize]);

  async function fetchData() {
    try {
      const res = await galleryService.getAll({
        page: page,
        pageSize,
      });
      if (res.success === true) {
        setGalleryList(res.data.data);
        setCountOfImage(res.data.data.length);
      }
    } catch (err) {
      addToast({
        error: true,
        msg:
          typeof err === "string" ? err.replace(/<[^>]*>/g, "") : err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  }

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const setBio = (bioContent) => {
    props.setShowConfirmInfModal(true);
    updateForm({ bio: bioContent });
  };

  const enterCalled = () => {
    let info = document.activeElement.parentElement.closest(".form__personal");
    if (info) {
      refInfo.current.click();
    }
  };

  const chkEditorVal = (item) => {
    if (!item || item === "") {
      return true;
    }
    try {
      const parsed = JSON.parse(item);
      return (
        !parsed.blocks || !parsed.blocks[0] || parsed.blocks[0].text === ""
      );
    } catch {
      return item.trim() === "";
    }
  };
  console.log("🚀 ~ saveChanges ~ form:", form);

  const saveChanges = async () => {
    let error = 0;
    if (
      form.gender === "" ||
      form.categories.length === 0 ||
      form.displayname === "" ||
      form.country_id === "" ||
      form.country_id === 0 ||
      form.reach === "" ||
      form.bio === "" ||
      chkEditorVal(form.bio) === true ||
      (form.audience_0_12 !== "1" &&
        form.audience_13_17 !== "1" &&
        form.audience_18_24 !== "1" &&
        form.audience_25_34 !== "1" &&
        form.audience_35_44 !== "1" &&
        form.audience_45_54 !== "1" &&
        form.audience_55_64 !== "1" &&
        form.audience_65plus !== "1") ||
      parseInt(galleryList.length) + parseInt(newGalleryUploaded.length) < 3 ||
      (form.profile_img === "" && form.uploaded_profile_photo === "")
    ) {
      error = 1;
    }

    if (error === 1) {
      setError(true);
      if (props.saveProfile === true) {
        props.setSaveProfile(false);
      }
      props.setSaveProfileFormValid(false);
      addToast({
        error: true,
        date: new Date(),
        msg: "Enter all details to save.",
      });
    } else {
      props.setSaveProfileFormValid(true);
      const formData = new FormData();
      if (form.uploaded_profile_photo !== "") {
        const croppedFile = await blobUrlToFile(form.uploaded_profile_photo);
        formData.append("uploaded_profile_photo", croppedFile);
      }

      formData.append("profile_img", form.profile_img || "");
      formData.append("displayname", form.displayname);
      formData.append("linktree", form.linktree);
      formData.append("bio", form.bio);
      formData.append("category", form.categories.join(","));
      formData.append("gender", form.gender);
      formData.append("country_id", form.country_id);
      formData.append("reach", form.reach);
      formData.append("audience_0_12", form.audience_0_12);
      formData.append("audience_13_17", form.audience_13_17);
      formData.append("audience_18_24", form.audience_18_24);
      formData.append("audience_25_34", form.audience_25_34);
      formData.append("audience_35_44", form.audience_35_44);
      formData.append("audience_45_54", form.audience_45_54);
      formData.append("audience_55_64", form.audience_55_64);
      formData.append("audience_65plus", form.audience_65plus);
      formData.append("request_type", "Infprofile");
      formData.append("newuploadedimage", JSON.stringify(newGalleryUploaded));

      try {
        const res = await influencerService.savePublicProfileDetails(formData);
        console.log("res",res)
        props.setShowConfirmInfModal(false);
        fetchData();
        fetchInfluencerData();
        setPublicProfileData();
        addToast({
          error: false,
          date: new Date(),
          msg: "Profile saved successfully",
        });
        if (props.saveProfile === true) {
          props.setSaveProfile(false);
          props.setShowConfirmInfModal(false);
          navigate("/influencer/gallery");
        }
      } catch (err) {
        if (err === "No Content") {
          addToast({
            error: true,
            date: new Date(),
            msg: "Enter all details to save.",
          });
        } else {
          addToast({ error: true, date: new Date(), msg: err });
        }
      }
    }
  };

  async function blobUrlToBlob(croppedImageUrl) {
    try {
      const response = await fetch(croppedImageUrl);
      if (!response.ok) throw new Error("Failed to fetch image");
      return response.blob();
    } catch (err) {
      throw new Error("Error processing image: " + err.message);
    }
  }

  async function blobUrlToFile(
    croppedImageUrl,
    filename = "profile_image.png"
  ) {
    try {
      const blob = await blobUrlToBlob(croppedImageUrl);
      return new File([blob], filename, { type: blob.type });
    } catch (err) {
      throw err;
    }
  }

  const uploadFile = () => {
    setTab("add");
  };

  const removeItem = (indexToRemove) => {
    setNewGalleryUploaded((prevItems) =>
      prevItems.filter((_, index) => index !== indexToRemove)
    );
    setShowConfirmDelete(false);
  };

  return (
    <>
      <div className="min-h-screen">
        <div className=" mx-auto">
          {/* Header Section */}
          {/* <div className="text-center mb-5">
            {/* <h1 className="text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-2">
              Public Profile
            </h1>
            <p className="text-lg text-emerald-700  mx-auto leading-relaxed">
              Complete your profile to be discovered by brands and showcase your
              influencer presence
            </p>
          </div> */}

          <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl shadow-emerald-100/50 border border-emerald-100 overflow-hidden">
            <div className="p-8">
              <MyProfileListing
                form={form}
                setInput={setInput}
                addToast={addToast}
                error={error}
                enterCalled={enterCalled}
                refInfo={refInfo}
                updateForm={updateForm}
                setShowConfirmInfModal={props.setShowConfirmInfModal}
                countries={country}
                states={configData?.state}
                setBio={setBio}
                refAbout={refAbout}
                categories={
                  categoriesData.map
                    ? categoriesData.map((cat) => cat.name)
                    : []
                }
                categoriesData={categoriesData}
                galleryList={galleryList}
                uploadFile={uploadFile}
                newGalleryUploaded={newGalleryUploaded}
                countOfImage={countOfImage}
                setShowConfirmDelete={setShowConfirmDelete}
                setIndexForAction={setIndexForAction}
                PublicProfileData={PublicProfileData}
              />
            </div>

            {/* Save Button Section */}
            <div className="px-8 py-6 bg-gradient-to-r from-emerald-50 to-teal-50 border-t border-emerald-200/60">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <div className="text-sm text-emerald-700">
                  {isFormValidToSave ? (
                    <span className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                      All changes saved
                    </span>
                  ) : (
                    "Make sure all required fields are filled"
                  )}
                </div>
                <button
                  onClick={saveChanges}
                  className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl hover:from-emerald-600 hover:to-teal-600 focus:ring-4 focus:ring-emerald-200 focus:ring-offset-2 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-105 transform flex items-center gap-2 group"
                >
                  <svg
                    className="w-5 h-5 group-hover:scale-110 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>

        {tab === "add" && (
          <GalleryAdd
            close={() => setTab(null)}
            setTab={setTab}
            setToastList={setToastList}
            toastList={toastList}
            uploadOnServer={false}
            setNewGalleryUploaded={setNewGalleryUploaded}
            newGalleryUploaded={newGalleryUploaded}
            setShowConfirmInfModal={props.setShowConfirmInfModal}
          />
        )}
      </div>

      {showConfirmDelete === true && (
        <Modal addClass="modalAsset" close={() => setShowConfirmDelete(false)}>
          <div className="modal__rate p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-red-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </div>
              <h6 className="text-xl font-bold text-gray-900 mb-2">
                Delete Image?
              </h6>
              <p className="text-gray-600">
                Are you sure you want to delete this gallery image? This action
                cannot be undone.
              </p>
            </div>
            <div className="flex gap-4 justify-center">
              <button
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 focus:ring-2 focus:ring-gray-200 transition-all duration-200 font-medium"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancel
              </button>
              <button
                className="px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:ring-2 focus:ring-red-200 transition-all duration-200 font-medium"
                onClick={() => removeItem(indexForAction)}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
